// Shopify Variant-Specific Image Filter - Studio Theme (Fixed)
// Place in Assets folder as variant-image-filter.js

(function() {
  'use strict';

  console.log('🎨 Variant image filter loading...');

  let slideData = [];
  let isInitialized = false;

  function findProductSlides() {
    // Try multiple selectors
    let slides = document.querySelectorAll('li[id*="Slide-template"]');
    
    if (slides.length === 0) {
      slides = document.querySelectorAll('li[id*="slide-template"]');
    }
    
    if (slides.length === 0) {
      slides = document.querySelectorAll('.product__media-item, .product-single__photo, li[class*="slide"]');
    }

    if (slides.length === 0) {
      // Try finding any li within the gallery
      const gallery = document.querySelector('[id*="GalleryViewer"], [id*="Slider-Gallery"], .product-media-gallery');
      if (gallery) {
        slides = gallery.querySelectorAll('li');
      }
    }

    return slides;
  }

  function init() {
    const productSlides = findProductSlides();
    
    if (productSlides.length === 0) {
      console.warn('❌ No product slides found. Retrying...');
      return false;
    }

    console.log(`✅ Found ${productSlides.length} product slides`);

    // Store slide data with image source and alt
    slideData = Array.from(productSlides).map(slide => {
      const img = slide.querySelector('img');
      const src = img?.src || img?.dataset?.src || '';
      const alt = img?.alt || '';
      
      console.log('📸 Slide:', {
        src: src.substring(src.lastIndexOf('/') + 1, src.indexOf('?') > 0 ? src.indexOf('?') : src.length),
        alt: alt || '(no alt)'
      });
      
      return {
        element: slide,
        src: src,
        alt: alt,
        visible: true
      };
    });

    isInitialized = true;
    return true;
  }

  function normalizeColorName(color) {
    return color.toLowerCase().replace(/\s+/g, '').replace(/-/g, '').replace(/_/g, '');
  }

  function filterSlidesByColor(selectedColor) {
    if (!isInitialized) {
      console.warn('⚠️ Not initialized yet');
      return;
    }

    if (!selectedColor) {
      showAllSlides();
      return;
    }
    
    const color = selectedColor.trim();
    const normalizedColor = normalizeColorName(color);
    
    console.log(`🎯 Filtering by: "${color}" (normalized: "${normalizedColor}")`);
    
    let visibleCount = 0;
    
    slideData.forEach(slide => {
      const src = slide.src.toLowerCase();
      const alt = slide.alt.toLowerCase();
      const normalizedSrc = normalizeColorName(src);
      const normalizedAlt = normalizeColorName(alt);
      
      // Multiple matching strategies
      const matchStrategies = [
        normalizedSrc.includes(normalizedColor),
        normalizedAlt.includes(normalizedColor),
        src.includes(color.toLowerCase()),
        alt.includes(color.toLowerCase()),
        src.includes(color.toLowerCase().replace(/\s+/g, '_')),
        src.includes(color.toLowerCase().replace(/\s+/g, '-'))
      ];
      
      const shouldShow = matchStrategies.some(match => match) || (!slide.src && !slide.alt);
      
      if (shouldShow) {
        slide.element.style.display = '';
        slide.element.style.visibility = 'visible';
        slide.element.classList.remove('hidden', 'hide');
        slide.element.removeAttribute('hidden');
        slide.visible = true;
        visibleCount++;
        console.log(`  ✓ SHOW: ${slide.alt || slide.src.substring(slide.src.lastIndexOf('/') + 1, 50)}`);
      } else {
        slide.element.style.display = 'none';
        slide.element.style.visibility = 'hidden';
        slide.element.classList.add('hidden');
        slide.element.setAttribute('hidden', '');
        slide.visible = false;
        console.log(`  ✗ HIDE: ${slide.alt || slide.src.substring(slide.src.lastIndexOf('/') + 1, 50)}`);
      }
    });

    console.log(`✅ Result: Showing ${visibleCount} of ${slideData.length} slides`);
    updateSlider();
  }

  function showAllSlides() {
    if (!isInitialized) return;
    
    console.log('📋 Showing all slides');
    slideData.forEach(slide => {
      slide.element.style.display = '';
      slide.element.style.visibility = 'visible';
      slide.element.classList.remove('hidden', 'hide');
      slide.element.removeAttribute('hidden');
      slide.visible = true;
    });
    updateSlider();
  }

  function updateSlider() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
      
      const firstVisible = Array.from(document.querySelectorAll('li[id*="lide-template"]')).find(
        el => el.style.display !== 'none' && !el.hasAttribute('hidden')
      );
      
      if (firstVisible) {
        firstVisible.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }, 100);
  }

  function getSelectedColorFromButtons() {
    // Method 1: Look for Color fieldset
    const colorFieldset = Array.from(document.querySelectorAll('fieldset')).find(fieldset => {
      const legend = fieldset.querySelector('legend');
      return legend && legend.textContent.trim().toLowerCase() === 'color';
    });

    if (colorFieldset) {
      const checkedInput = colorFieldset.querySelector('input:checked');
      if (checkedInput) {
        const label = colorFieldset.querySelector(`label[for="${checkedInput.id}"]`);
        if (label) {
          const colorText = label.textContent.trim();
          console.log('🔘 Color from fieldset:', colorText);
          return colorText;
        }
      }
    }

    // Method 2: Any checked color input
    const colorInput = document.querySelector('input[type="radio"]:checked');
    if (colorInput) {
      const label = document.querySelector(`label[for="${colorInput.id}"]`);
      if (label && label.closest('fieldset')) {
        const fieldset = label.closest('fieldset');
        const legend = fieldset.querySelector('legend');
        if (legend && legend.textContent.toLowerCase().includes('color')) {
          console.log('🔘 Color from input:', label.textContent.trim());
          return label.textContent.trim();
        }
      }
    }

    return null;
  }

  // Event listeners
  function setupEventListeners() {
    // Listen for any radio button change
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[type="radio"]')) {
        console.log('🔄 Radio changed');
        setTimeout(() => {
          const color = getSelectedColorFromButtons();
          if (color) {
            filterSlidesByColor(color);
          }
        }, 100);
      }
    });

    // Listen for clicks on labels
    document.addEventListener('click', function(e) {
      if (e.target.matches('label') || e.target.closest('label')) {
        console.log('🖱️ Label clicked');
        setTimeout(() => {
          const color = getSelectedColorFromButtons();
          if (color) {
            filterSlidesByColor(color);
          }
        }, 150);
      }
    });
  }

  // Initialize with retry logic
  function initWithRetry(attempts = 0, maxAttempts = 10) {
    console.log(`Attempt ${attempts + 1}/${maxAttempts} to find slides...`);
    
    const success = init();
    
    if (success) {
      console.log('✅ Initialization successful!');
      setupEventListeners();
      
      // Apply initial filter
      setTimeout(() => {
        const initialColor = getSelectedColorFromButtons();
        if (initialColor) {
          console.log('🚀 Initial color detected:', initialColor);
          filterSlidesByColor(initialColor);
        } else {
          console.log('ℹ️ No initial color selected');
        }
      }, 500);
    } else if (attempts < maxAttempts) {
      setTimeout(() => initWithRetry(attempts + 1, maxAttempts), 500);
    } else {
      console.error('❌ Failed to initialize after', maxAttempts, 'attempts');
    }
  }

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => initWithRetry(), 1000);
    });
  } else {
    setTimeout(() => initWithRetry(), 1000);
  }

})();